
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class QualityInspectionGrid extends Serenity.EntityGrid<QualityInspectionRow, any> {
        protected getColumnsKey() { return 'Production.QualityInspection'; }
        protected getDialogType() { return QualityInspectionDialog; }
        protected getIdProperty() { return QualityInspectionRow.idProperty; }
        protected getInsertPermission() { return QualityInspectionRow.insertPermission; }
        protected getLocalTextPrefix() { return QualityInspectionRow.localTextPrefix; }
        protected getService() { return QualityInspectionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}